import { computed } from "mobx";
import * as moment from 'moment';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model, OData, $data } from 'src/core/services/data/JayDataContext';

import { FormatService } from "src/core/services/format.service";

export class RulesListDataService extends DataService<typeof Model.Rules.Logic.ViewModels.RuleSummary, Model.Rules.Logic.ViewModels.RuleSummary, RuleSummary> {

	constructor(contextService: any, entitySet: (context: OData.Container) => $data.EntitySet<typeof Model.Rules.Logic.ViewModels.RuleSummary, Model.Rules.Logic.ViewModels.RuleSummary>, private formatService: FormatService) {
		super(contextService, entitySet);
	}

	protected map(entity: Model.Rules.Logic.ViewModels.RuleSummary): RuleSummaryModel {
		return new RuleSummaryModel(entity, this.formatService);
	}

	public static make(context: any, formatService: FormatService): RulesListDataService {
		return new RulesListDataService(context, ctx => ctx.RuleSummaries, formatService);
	}
}

export class RuleSummaryModel extends EntityModel<Model.Rules.Logic.ViewModels.RuleSummary, RuleSummary> implements RuleSummary {


	constructor(entity: Model.Rules.Logic.ViewModels.RuleSummary, private formatService: FormatService) {
		super(entity);
	}

	@property<RuleSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<RuleSummaryModel>(o => o.entity.name, (o, value) => o.entity.name = value)
	public name: string;

	@property<RuleSummaryModel>(o => o.entity.eventName, (o, value) => o.entity.eventName = value)
	public eventName: string;

	@property<RuleSummaryModel>(o => o.entity.eventTypeFullName, (o, value) => o.entity.eventTypeFullName = value)
	public eventTypeFullName: string;

	@property<RuleSummaryModel>(o => o.entity.isActive, (o, value) => o.entity.isActive = value)
	public isActive: boolean;

	@property<RuleSummaryModel>(o => o.entity.description, (o, value) => o.entity.description = value)
	public description: string;

	@property<RuleSummaryModel>(o => o.entity.eventDescription, (o, value) => o.entity.eventDescription = value)
	public eventDescription: string;

	@property<RuleSummaryModel>(o => o.entity.mode, (o, value) => o.entity.mode = value)
	public mode: number;

	@property<RuleSummaryModel>(o => o.entity.executionDeadline, (o, value) => o.entity.executionDeadline = value)
	public executionDeadline: Date;

	@computed
	public get executionDateText(): string {
		return this.lastExecutionTime == null ? null : "on " + this.formatService.toString('date-time', this.executionDeadline, "utc");
	}

	@property<RuleSummaryModel>(o => o.entity.executionTimeSpan, (o, value) => o.entity.executionTimeSpan = value)
	public executionTimeSpan: string;

	@property<RuleSummaryModel>(o => o.entity.lastExecutionTime, (o, value) => o.entity.lastExecutionTime = value)
	public lastExecutionTime: Date;

	@computed
	public get isIdle(): boolean {
		const min = "0001-01-02";
		return !moment.utc(this.lastExecutionTime).isAfter(min);
	}

	@computed
	public get dateText(): string {
		const min = "0001-01-02";
		return this.lastExecutionTime == null || !moment.utc(this.lastExecutionTime).isAfter(min) ? "Not executed" : "on " + this.formatService.toString('date-time', this.lastExecutionTime, "utc");
	}

	@property<RuleSummaryModel>(o => o.entity.lastExecutionMessage, (o, value) => o.entity.lastExecutionMessage = value)
	public lastExecutionMessage: string;

	@computed
	public get modeText(): string {
		switch (this.entity.mode) {
			case 0:
				return 'On entity change';
			case 1:
				return 'Scheduled';
			case 2:
				return 'Recurring';
		}
		return null;
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/list/rules-list.data.ts